var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "418px",
    viewBox: "0 0 512 418",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-715.000000, -1165.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-(1)",
    transform: "translate(715.000000, 1165.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.392,104.077333 C480.213333,89.2933333 497.728,70.84 512,49.592 L512,49.5706667 C492.949333,57.912 472.682667,63.4586667 451.52,66.1466667 C473.28,53.1546667 489.898667,32.7386667 497.706667,8.14133333 C477.418667,20.2373333 455.018667,28.7706667 431.146667,33.5493333 C411.882667,13.0266667 384.426667,0.333333333 354.474667,0.333333333 C296.362667,0.333333333 249.578667,47.5013333 249.578667,105.314667 C249.578667,113.634667 250.282667,121.634667 252.010667,129.250667 C164.757333,124.984 87.5306667,83.1706667 35.648,19.448 C26.6026667,35.1706667 21.2693333,53.1546667 21.2693333,72.504 C21.2693333,108.856 39.9786667,141.069333 67.904,159.736 C51.0293333,159.416 34.496,154.509333 20.48,146.808 L20.48,147.96 C20.48,198.968 56.8533333,241.336 104.576,251.106667 C96.0213333,253.453333 86.72,254.562667 77.056,254.562667 C70.336,254.562667 63.552,254.178667 57.1946667,252.770667 C70.784,294.328 109.397333,324.898667 155.264,325.901333 C119.552,353.826667 74.1973333,370.658667 25.1093333,370.658667 C16.512,370.658667 8.256,370.274667 -5.68434189e-14,369.229333 C46.5066667,399.202667 101.589333,416.333333 161.024,416.333333 C346.261333,416.333333 466.986667,261.794667 459.392,104.077333 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6742249d0df3613ae4bb66830a7f86e9.svg";
export { ForwardRef as ReactComponent };